'use strict';

/* global yith_wcaf */

import { $, labels } from '../../../src/globals.js';
import YITH_WCAF_Admin_Ajax_Modal from './yith-wcaf-admin-ajax-modal';
import YITH_WCAF_Ajax from '../../../src/modules/ajax.js';

export default class YITH_WCAF_Edit_Gateway_Modal extends YITH_WCAF_Admin_Ajax_Modal {
	constructor( $opener, args ) {
		super( $opener, {
			title( data ) {
				return data?.title;
			},
			blockTarget() {
				return this.$target.closest( 'table' );
			},
			data() {
				const $tr = this.$target.closest( 'tr' );

				if ( ! $tr.length ) {
					return {};
				}

				return {
					gateway_id: $tr.data( 'id' ),
					title: $tr.data( 'name' ),
				};
			},
			width: 450,
			...args,
		} );
	}

	async onOpen() {
		await super.onOpen();

		// wrap content inside form.
		const $form = $( '<form/>' ),
			$content = this.modal.elements.content;

		$content.children().wrapAll( $form );

		// append save button to modal content
		const $pSubmit = $( '<p/>', {
				class: 'form-row submit',
			} ),
			$submitButton = $( '<button/>', {
				class: 'submit button-primary',
				text: labels?.generic_save_button,
			} );

		$pSubmit.appendTo( $content.find( 'form' ) ).append( $submitButton );

		// repeat submit button int after appending new one.
		this.initSubmit();
	}

	onSubmit() {
		const $content = this.modal.elements.content;

		if ( ! this.beforeSubmit() ) {
			return false;
		}

		this.hideErrorMessage();

		YITH_WCAF_Ajax.post
			.call( $content, 'save_gateway_options', 'save_gateway_options', {
				...this.args.data.call( this ),
				...this.serialize(),
			} )
			.done( ( data ) => {
				if ( 'function' === typeof this.args?.onSubmitSuccess ) {
					this.args?.onSubmitSuccess( data?.data );
				}

				if ( data?.success ) {
					this.modal.close();
				} else if ( data?.data?.message ) {
					this.showErrorMessage( data.data.message );
				}
			} );

		return false;
	}
}
